<nb-card class="token-usage-dialog">
  <nb-card-header>
    <div class="dialog-title">
      <h4>Token Usage</h4>
      <span class="company-name">{{ data?.company_name || data?.email }}</span>
      <div class="client-meta">
        <span>Client ID: {{ data?.id || '-' }}</span>
        <span>Registered Email: {{ data?.email || '-' }}</span>
      </div>
    </div>
    <button nbButton ghost status="basic" (click)="dialogRef.close()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body [nbSpinner]="loading">
    <div class="toolbar">
      <nb-select [(selected)]="period" (selectedChange)="loadUsage()">
        <nb-option *ngFor="let option of periods" [value]="option.value">
          {{ option.label }}
        </nb-option>
      </nb-select>
      <button
        nbButton
        size="small"
        status="primary"
        [disabled]="syncLoading"
        [nbSpinner]="syncLoading"
        (click)="scheduleSync()"
      >
        <nb-icon icon="refresh-outline"></nb-icon>
        Client Sync starten
      </button>
    </div>

    <ng-container *ngIf="usage">
      <div class="period-line">
        <span>{{ usage.project_name }}</span>
        <span>{{ periodLabel() }}</span>
        <span>Letzter Sync: {{ date(usage.sync.last_synced_at) }}</span>
        <span>Intervall: {{ syncIntervalLabel() }}</span>
      </div>

      <div
        class="drift-banner"
        *ngIf="tokenDriftIsSignificant()"
        [class.drift-banner--over]="tokenDrift() > 0"
      >
        <nb-icon icon="alert-triangle-outline"></nb-icon>
        <span>
          Der Zaehler im Kundenportal steht auf
          <strong>{{ number(runtimeTokenTotal()) }}</strong>, LangSmith zaehlt
          <strong>{{ number(tokenTotal()) }}</strong> — Abweichung
          <strong>{{ tokenDriftLabel() }}</strong>. Der Kunde sieht den
          Zaehler, LangSmith ist der Ist-Stand.
        </span>
      </div>

      <div class="metrics">
        <div class="metric">
          <span>Total Tokens ({{ tokenMetricSource() }})</span>
          <strong>{{ number(tokenTotal()) }}</strong>
        </div>
        <div class="metric">
          <span>Zaehler im Kundenportal</span>
          <strong>{{ number(runtimeTokenTotal()) }}</strong>
        </div>
        <div class="metric">
          <span>Input ({{ tokenMetricSource() }})</span>
          <strong>{{ number(tokenInput()) }}</strong>
        </div>
        <div class="metric">
          <span>Output ({{ tokenMetricSource() }})</span>
          <strong>{{ number(tokenOutput()) }}</strong>
        </div>
        <div class="metric">
          <span>Estimated Cost</span>
          <strong>{{ cost(usage.summary.total_cost) }}</strong>
        </div>
        <div class="metric">
          <span>Aktiver Plan</span>
          <strong>{{ activePlanName() }}</strong>
        </div>
        <div class="metric">
          <span>All Runs</span>
          <strong>{{ number(usage.summary.total_runs) }}</strong>
        </div>
        <div class="metric">
          <span>Model Calls</span>
          <strong>{{ number(usage.summary.llm_runs) }}</strong>
        </div>
        <div class="metric">
          <span>Traces</span>
          <strong>{{ number(usage.summary.trace_count) }}</strong>
        </div>
        <div class="metric">
          <span>Threads</span>
          <strong>{{ number(usage.summary.thread_count) }}</strong>
        </div>
        <div class="metric">
          <span>LangSmith Avg / Model Call</span>
          <strong>{{ number(usage.summary.avg_total_tokens_per_run) }}</strong>
        </div>
      </div>

      <section>
        <h5>Breakdown nach Run Name</h5>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Run</th>
                <th>Typ</th>
                <th>Calls</th>
                <th>Input</th>
                <th>Output</th>
                <th>Total</th>
                <th>Avg Total</th>
                <th>Kosten</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of usage.run_breakdown">
                <td>{{ row.run_name }}</td>
                <td>{{ row.run_type }}</td>
                <td>{{ number(row.run_count) }}</td>
                <td>{{ number(row.input_tokens) }}</td>
                <td>{{ number(row.output_tokens) }}</td>
                <td>{{ number(row.total_tokens) }}</td>
                <td>{{ number(row.avg_total_tokens_per_run) }}</td>
                <td>{{ cost(row.total_cost) }}</td>
              </tr>
              <tr *ngIf="usage.run_breakdown.length === 0">
                <td colspan="8">Noch keine aggregierten Run-Daten vorhanden.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h5>Tageswerte</h5>
        <p class="chart-caption">
          All Runs umfasst alle LangSmith-Schritte; Model Calls sind die LLM-/Chat-Model-Runs.
          Threads werden aus LangSmith thread_id/session_id-Metadata gezählt.
        </p>
        <div class="daily-chart" *ngIf="usage.daily.length > 0">
          <div
            echarts
            [options]="dailyChartOptions"
            [autoResize]="true"
            theme="alphabees"
            class="daily-chart__canvas"
          ></div>
        </div>
        <div class="empty-state" *ngIf="usage.daily.length === 0">
          Fuer diese Periode liegen noch keine Tagesaggregate vor.
        </div>
      </section>
    </ng-container>
  </nb-card-body>
</nb-card>
